import { Component, ViewChild, ViewEncapsulation } from '@angular/core';
import { SessionService } from '@fi-app/utilities/fi-services/session.service';
import { HelpMenuComponent } from '@fi-app/components/help-menu/help-menu.component';
import { FiSupportService } from '@fi-shared/fi-support/fi-support.service';

@Component({
    selector: 'fi-main-toolbar',
    templateUrl: './main-toolbar.component.html',
    styleUrls: ['./main-toolbar.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false,
})
export class MainToolbarComponent {
    @ViewChild('fiHelpMenuComponent') fiHelpMenuComponent: HelpMenuComponent;
    readonly isNewContactSupportMode = true;

    constructor(
        private sessionService: SessionService,
        private supportService: FiSupportService,
    ) {}

    IsMobileSearchOpened = false;

    ToggleMobileDashboard() {
        this.sessionService.toggleDashboard();
    }

    notificationClick = () => {
        this.sessionService.toggleDashboard(false);
    };

    contactSupport() {
        this.isNewContactSupportMode
            ? this.supportService.checkOpenContactSupport()
            : this.fiHelpMenuComponent.openHelpMenu();
    }
}
